import { withState } from 'recompose';

export default withState('type', 'updateType', 'individual');
